import { request, type ApiResult } from '@/utils/request'

/** 后台「分享配置 → 公众号配置」中的公开部分（不含 AppSecret） */
export interface ShareConfigVO {
  appId?: string
  jsDomain?: string
  title?: string
  desc?: string
  cover?: string
}

/** wx.config 签名结果 */
export interface WxJsSdkSignatureVO {
  appId: string
  timestamp: number
  nonceStr: string
  signature: string
}

/**
 * 默认分享内容 + 公众号 AppID（公开接口，游客可访问）
 * GET /share/config
 */
export function getShareConfig(): Promise<ApiResult<ShareConfigVO>> {
  return request.getSilent<ShareConfigVO>('/share/config')
}

/**
 * 微信 JS-SDK 签名（公开接口，游客可访问）
 * GET /share/jssdk/signature?url=
 */
export function getJsSdkSignature(url: string): Promise<ApiResult<WxJsSdkSignatureVO>> {
  return request.getSilent<WxJsSdkSignatureVO>('/share/jssdk/signature', { url })
}
